module.exports = __webpack_public_path__ + "img/sort-checked.9c39b690.svg";